var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.261,
    height: 22.261,
    viewBox: "0 0 22.261 22.261",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.707 11.131) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.674,7.371l5.8-5.8a.922.922,0,1,0-1.3-1.3l-5.8,5.8L1.574.27a.922.922,0,0,0-1.3,1.3l5.8,5.8-5.8,5.8a.922.922,0,1,0,1.3,1.3l5.8-5.8,5.8,5.8a.922.922,0,1,0,1.3-1.3Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.75a7b4ba.svg";
export { ForwardRef as ReactComponent };